module.exports = __webpack_public_path__ + "ae136f98c6645488d80da437562ae6bc.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/uneven-27.png
// module id = 2231
// module chunks = 0